<template>
  <div>
    <el-drawer v-loading="loading" title="预销售订单" :visible.sync="show" size="90%" :before-close="handleClose" destroy-on-close center :close-on-click-modal="false">
      <el-form ref="form" :disabled="type == '查看'|| isRejectTo " :model="form" :rules="rules" label-width="130px">
        <el-card header="基础信息">
          <el-row>
            <el-col :span="6">
              <el-form-item label="预销售单据号">
                <el-input v-model="form.sn" :disabled="true" placeholder="自动带出" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据状态">
                <el-select v-model="form.status" :disabled="true" placeholder="请选择" @change="changeSalesType">
                  <el-option v-for="item in statusArr" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="车牌号">
                <el-input v-model="form.plateNumber" :disabled="true" placeholder="自动带出" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="车架号码">
                <el-input v-model="form.vinCode" :disabled="true" placeholder="自动带出" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="品牌">
                <el-input v-model="form.brand" :disabled="true" placeholder="自动带出" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="大系">
                <el-input v-model="form.hugeClass" :disabled="true" placeholder="自动带出" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="车系">
                <el-input v-model="form.carSeries" :disabled="true" placeholder="自动带出" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="车辆型号">
                <el-input v-model="form.model" :disabled="true" placeholder="自动带出" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="年款">
                <el-input v-model="form.yearPart" :disabled="true" placeholder="自动带出" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="排量">
                <el-input v-model="form.displacement" :disabled="true" placeholder="自动带出" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="车辆版本">
                <el-input v-model="form.vehicleVersion" :disabled="true" placeholder="自动带出" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="发动机型号">
                <el-input v-model="form.engineModel" :disabled="true" placeholder="自动带出" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="变速箱型号">
                <el-input v-model="form.gearboxModel" :disabled="true" placeholder="自动带出" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card header="订单明细">
          <el-tabs v-model="activePaneName">
            <el-tab-pane label="配件" name="mountings">
              <div style="margin-bottom: 10px;display: flex;justify-content: flex-end;">
                <el-button type="primary" @click="addMountingsLine()">配件明细</el-button>
                <!-- <el-button type="danger" @click="delectMountingsLine()">一键清空配件列表</el-button> -->
              </div>
              <el-table ref="mountingsTable" v-loading="showObj.mountings" height="400px" :data="form.mountingsList" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="产品编码" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="产品名称" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="销售类型" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="saleType">
                      <el-input v-model="scope.row.saleType" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="数量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="qty">
                      <!-- :prop="'mountingsList.' + scope.$index + '.qty'
                      " :rules="mountingsList.qty" -->
                      <el-input v-model.number="scope.row.qty" type="number" :disabled="true" placeholder="请填写" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="营销价格" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="marketingPrice">
                      <!-- :prop="'mountingsList.' + scope.$index + '.marketingPrice'
                      " :rules="mountingsList.marketingPrice" -->
                      <el-input v-model.number="scope.row.marketingPrice" type="number" :disabled="true" placeholder="请填写" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="客户" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'mountingsList.' + scope.$index + '.customerName'
                      " :rules="mountingsList.customerName">
                      <el-input v-model="scope.row.customerName" readonly placeholder="请点击图标选择">
                        <el-button slot="append" icon="el-icon-search" @click="selectSoldToParty(scope.$index)" />
                      </el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="批次号" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="batch">
                      <el-input v-model="scope.row.batch" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单位" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="OE码" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="oeCode">
                      <el-input v-model="scope.row.oeCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="废料底价" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="flotsamPrice">
                      <el-input v-model="scope.row.flotsamPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="废料产值" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="propertyValue">
                      <el-input v-model="scope.row.propertyValue" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column label="说明" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="note">
                      <el-input v-model="scope.row.note" placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" @click="handleMountingsDelete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <!-- <el-tab-pane label="废料" name="flotsam">
              <div style="margin-bottom: 10px;display: flex;justify-content: flex-end;">
                <el-button type="primary" @click="addFlotsamLine()">废料明细</el-button>
              </div>
              <el-table ref="flotsamTable" v-loading="showObj.flotsam" height="400px" :data="form.flotsamList" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip width="200">
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="订单数量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'flotsamList.' + scope.$index + '.qty'
                      " :rules="flotsamList.qty">
                      <el-input v-model="scope.row.qty" min="0" placeholder="请输入" type="number" @blur="sumLordDutyPrice(scope.row,scope.$index)" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单位" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税单价" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'flotsamList.' + scope.$index + '.taxPrice'
                      " :rules="flotsamList.taxPrice">
                      <el-input v-model="scope.row.taxPrice" min="0" placeholder="请输入" type="number" @blur="sumLordDutyPrice(scope.row,scope.$index)" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="税率(%)" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="taxRatio">
                      <el-input v-model="scope.row.taxRatio" :disabled="true" placeholder="头部的销售组织带出" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="lordDutyPrice">
                      <el-input v-model="scope.row.lordDutyPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="不含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="taxlessPrice">
                      <el-input v-model="scope.row.taxlessPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="说明" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="note">
                      <el-input v-model="scope.row.note" placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" @click="handleFlotsamDelete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane> -->
          </el-tabs>
        </el-card>
        <!-- <el-card header="附件信息">
          <el-row>
            <FileUpload :value.sync="form.loanOrderAccessoryParamList" :is-show-tip="false" />
          </el-row>
        </el-card> -->
        <!-- v-if="form.status != 3" -->
        <el-card header="流程审批">
          <div v-if="form.status <= 1 || form.status==null">
            <el-row>
              <el-col :span="8">
                <el-form-item label="选择流程模板" prop="flowPathTemplateId">
                  <el-select v-model="form.flowPathTemplateId" placeholder="选择模板" @change="getFlowTempInfoList">
                    <el-option v-for="item in flowPathOptions" :key="item.id" :label="item.templateName" :value="item.id" />
                  </el-select>
                </el-form-item>

              </el-col>

            </el-row>
            <!-- <el-row>
              <el-col :span="6">
                <el-button
                  type="primary"
                  style="margin-bottom: 5px;"
                  @click="addNodePerson()"
                >新增审批人</el-button>
              </el-col>
            </el-row> -->

            <el-table v-if="form.flowPathNodePersonModels && form.flowPathNodePersonModels.length>0" ref="elTable" style="width:50%" :data="form.flowPathNodePersonModels" border>
              <el-table-column label="节点名称" align="left" show-overflow-tooltip width="150">
                <template slot-scope="scope">
                  <el-form-item prop="nodePersonName">
                    {{ scope.row.nodePersonName }}
                    <!-- <el-input
                      v-model="scope.row.companyName"
                      disabled
                    /> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="审批人" align="left" show-overflow-tooltip width="auto">
                <template slot-scope="scope">
                  <el-form-item :prop="
                      'flowPathNodePersonModels.' + scope.$index + '.nodePerson'
                    " :rules="flowPathNodePersonModels.nodePerson">
                    <el-input v-model="scope.row.nodePerson" readonly placeholder="请点击图标选择">
                      <el-button v-if="scope.row.variable" slot="append" icon="el-icon-search" @click="selectNodePerson(scope.$index)" />
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                  <el-button
                    type="text"flowLoad
                    @click="deleteNodePerson(scope.$index)"
                  >删除</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
          <Flow ref="flow" :disabled="type == '查看' || form.status > 2" :custom-event="true" :flow-id="form.flowId" @flowLoad="flowLoad" @complete="onComplete" @refresh="flowRefresh" @rejectTo="flowRejectTo" />
        </el-card>
        <el-row style="padding: 10px 20px">
          <el-button :disabled="[3].includes(form.status)" :loading="loading" type="primary" @click="submitForm('form',false)">保存</el-button>
          <el-button v-if="form.id && (form.status == 1 || !form.status)" type="primary" @click="saveAndSubmit()">提交审核</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-row>
      </el-form>
    </el-drawer>
    <!-- 选择审批人 -->
    <el-dialog class="dialog" :title="'选择审批人'" :visible.sync="showObj.nodePerson" width="30%" :before-close="nodePersonClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.nodePerson.nodePerson" clearable placeholder="请输入审批人名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getNodePersonDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.nodePerson" border height="300" @selection-change="handleNodePersonSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="审批人" align="left" prop="nodePerson" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.nodePerson.total" :page.sync="pagination.nodePerson.current" :limit.sync="pagination.nodePerson.size" @pagination="getNodePersonDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="nodePersonClose">取消</el-button>
        <el-button type="primary" @click="nodePersonConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 客户 -->
    <el-dialog class="dialog" :title="'选择客户'" :visible.sync="showObj.soldToParty" width="40%" :before-close="soldToPartyClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.soldToParty.customerApplyName" clearable placeholder="请输入客户名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getSoldToPartyDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.soldToParty" border height="300" @selection-change="handleSoldToPartySelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="客户编码" align="left" prop="customerApplyNo" show-overflow-tooltip />
        <el-table-column label="客户名称" align="left" prop="customerApplyName" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.soldToParty.total" :page.sync="pagination.soldToParty.current" :limit.sync="pagination.soldToParty.size" @pagination="getSoldToPartyDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="soldToPartyClose">取消</el-button>
        <el-button type="primary" @click="soldToPartyConfirm">确认</el-button>
        <el-button type="primary" @click="soldToPartyAllConfirm">批量选择</el-button>
      </span>
    </el-dialog>
    <!-- 产品配料 -->
    <el-dialog class="dialog" title="产品配料" :visible.sync="showObj.mountings" width="70%" :before-close="mountingsClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.mountings.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.mountings.productCode" clearable placeholder="请输入产品编码" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.mountings.oeCode" clearable placeholder="请输入OE" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.mountings.carNo" clearable placeholder="请输入车牌" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getMountings('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.mountings" :data="dialog.mountings" border height="300" @selection-change="handleMountingsChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" show-overflow-tooltip />
        <el-table-column label="OE" align="left" prop="oeCode" show-overflow-tooltip />
        <el-table-column label="车辆ID" align="left" prop="carId" show-overflow-tooltip />
        <el-table-column label="车牌" align="left" prop="carNo" show-overflow-tooltip />
        <el-table-column label="品牌" align="left" prop="brand" show-overflow-tooltip />
        <el-table-column label="车系" align="left" prop="series" show-overflow-tooltip />
        <el-table-column label="年款" align="left" prop="modelYear" show-overflow-tooltip />
        <!-- <el-table-column
            label="燃料类型"
            align="left"
            prop="oeCode"
            show-overflow-tooltip
          /> -->
        <el-table-column label="发动机型号" align="left" prop="engineModel" show-overflow-tooltip />
        <el-table-column label="变速箱型号" align="left" prop="transmissionModel" show-overflow-tooltip />
        <el-table-column label="排量" align="left" prop="displacement" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.mountings.total" :page.sync="pagination.mountings.current" :limit.sync="pagination.mountings.size" @pagination="getMountings" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mountingsClose">取消</el-button>
        <el-button type="primary" @click="mountingsConfirm">确认</el-button>
      </span>
    </el-dialog>

  </div>

</template>

<script>

import FileUpload from '@/components/FileUpload/index'
import { getByGeneralManager } from '@/api/crm/base/audit'
import Pagination from '@/components/Pagination'
import Flow from '@/components/Flow'
import format from '@/utils/formatter'
import { getEnumItems } from '@/utils/enum'
import { getByPathTemplate, getFlowTempInfo } from '@/api/flow/processConfiguration'
import { getPagePopup as getMountingsApi } from '@/api/crm/product/fittings'
import { getPage as getByCustomerApply } from '@/api/crm/customer/customerApplication'
import {
  get,
  saveOrUpdate,
  submit

} from '@/api/crm/order/preSaleOrder'
import { mergeObjectArrayWithoutDuplicates } from '@/utils/index'
export default {
  name: 'PreSaleOrderEdit',
  components: {
    Pagination,
    FileUpload,
    Flow
  },
  filters: {
    operateCategoryFilters(e) {
      const arr = e.split(',')
      const arr1 = getEnumItems('Crm_Business_Category')
      const arr2 = []
      for (const item of arr) {
        for (const v of arr1) {
          if (v.code === item) {
            arr2.push(v.name)
          }
        }
      }
      console.log(arr2.join())
      return arr2.join()
    }
  },
  props: {
    show: {
      type: Boolean,
      default() {
        return false
      }
    },
    editId: Number
  },
  data() {
    return {
      companyOptions: [],
      salesOrganizationOptions: [],
      channelDistributioOption: [],
      productTeamOption: [],
      businessTypeOptions: [],
      factoryOptions: [],
      flowPathOptions: [],
      orderReasonOptions: getEnumItems('Crm_Order_Reason'),
      format: format,
      type: '',
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL,
      loading: false,
      form: {
        orderTime: format.formatDate(new Date(), 'yyyy-MM-dd'),
        crmPreSaleOrderLineModels: [],
        flotsamList: [],
        mountingsList: [],
        salesOrganizationId: null,
        channelOfDistributionId: null,
        productTeamId: null,
        salesType: null,
        soldToPartyName: null,
        deliveryOrderSn: null,
        businessTypeId: null,
        status: null,
        flowPathNodePersonModels: [],
        flowPathTemplateId: null,
        roleId: null
      },
      statusArr: [{ value: 1, label: '制单' }, { value: 2, label: '审核中' }, { value: 3, label: '审核完成' }],
      flowPathNodePersonModels: {
        nodePerson: [
          { required: true, message: '审批人不能为空', trigger: 'change' }
        ]
      },
      mountingsList: {
        qty: [
          { required: true, message: '数量不能为空', trigger: 'blur' }
        ],
        marketingPrice: [
          { required: true, message: '营销单价不能为空', trigger: 'blur' }
        ],
        customerName: [
          { required: true, message: '客户不能为空', trigger: 'change' }
        ]
      },
      flotsamList: {
        qty: [
          { required: true, message: '废料订单数量不能为空', trigger: 'blur' }
        ],
        taxPrice: [
          { required: true, message: '废料含税单价不能为空', trigger: 'blur' }
        ]
      },
      rules: {

      },
      clientClassOptions: [],
      activePaneName: 'mountings',
      showObj: {
        mountings: false,
        flotsam: false,
        soldToParty: false,
        nodePerson: false
      },
      loadingObj: {
        mountings: false,
        flotsam: false,
        soldToParty: false,
        nodePerson: false
      },
      // 分页
      pagination: {
        mountings: {
          total: 0,
          size: 20,
          current: 1
        },
        soldToParty: {
          total: 0,
          size: 20,
          current: 1
        },
        flotsam: {
          total: 0,
          size: 20,
          current: 1
        },
        nodePerson: {
          total: 0,
          size: 20,
          current: 1
        }
      },
      dialog: {
        mountings: [],
        soldToParty: [],
        flotsam: [],
        nodePerson: []
      },
      condition: {
        mountings: {},
        soldToParty: {},
        flotsam: {},
        nodePerson: {}
      },
      selection: {
        mountings: [],
        soldToParty: [],
        flotsam: [],
        nodePerson: []
      },
      isDisabled: false,
      isRejectTo: false

    }
  },
  watch: {
    show(show) {
      if (!show) {
        return
      }
      this.init()
      this.flowPathNodePersonModels.nodePerson[0].required = false
      if (this.editId == null) {
        this.form = this.$options.data.call(this).form
        return
      }
      this.getData()
    }
  },
  methods: {
    init() {
      getByPathTemplate({ templateType: '预销售订单' }, { current: 1, size: 100 }).then((res) => {
        const { records } = res.data
        this.flowPathOptions = records
        console.log(this.flowPathOptions)
      })
      console.log(this.form.orderTime)
    },
    // 基础数据
    // 售达方
    selectSoldToParty(index) {
      this.soldToPartyIndex = index
      this.showObj.soldToParty = true
      this.getSoldToPartyDialog()
    },
    async getSoldToPartyDialog() {
      this.loadingObj.soldToParty = true

      this.condition.soldToParty.status = 3
      const reponse = await getByCustomerApply(this.condition.soldToParty, this.pagination.soldToParty)
      const { current, total, size, records } = reponse.data
      this.dialog.soldToParty = records
      this.pagination.soldToParty.total = total
      this.pagination.soldToParty.current = current
      this.pagination.soldToParty.size = size
      this.loadingObj.soldToParty = false
    },
    handleSoldToPartySelectionChange(val) {
      this.selection.soldToParty = val
    },
    soldToPartyConfirm() {
      if (this.selection.soldToParty.length > 1) {
        this.$message.warning('只能选择一位客户！')
      } else {
        this.showObj.soldToParty = false
        this.$set(this.form.mountingsList[this.soldToPartyIndex], 'customerName', this.selection.soldToParty[0].customerApplyName)
        this.form.mountingsList[this.soldToPartyIndex].customerId = this.selection.soldToParty[0].id
        this.form.mountingsList[this.soldToPartyIndex].customerCode = this.selection.soldToParty[0].customerApplyNo
      }
    },
    soldToPartyAllConfirm() {
      if (this.selection.soldToParty.length > 1) {
        this.$message.warning('只能选择一位客户！')
      } else {
        this.showObj.soldToParty = false
        for (const item of this.form.mountingsList) {
          item.customerName = this.selection.soldToParty[0].customerApplyName
          item.customerId = this.selection.soldToParty[0].id
          item.customerCode = this.selection.soldToParty[0].customerApplyNo
        }
        // this.$set(this.form.mountingsList[this.soldToPartyIndex], 'customerName', this.selection.soldToParty[0].customerApplyName)
        // this.form.mountingsList[this.soldToPartyIndex].customerId = this.selection.soldToParty[0].id
        // this.form.mountingsList[this.soldToPartyIndex].customerCode = this.selection.soldToParty[0].customerApplyNo
      }
    },
    soldToPartyClose() {
      this.showObj.soldToParty = false
    },
    // 配件
    addMountingsLine() {
      // if (!this.form.deliveryOrderSn) {
      //   this.$message.warning('请先选择交货单号，再添加订单明细')
      //   return
      // }
      this.showObj.mountings = true
      this.getMountings()
    },
    delectMountingsLine() {
      this.form.mountingsList = []
    },
    async getMountings(type = '') {
      if (type === 'refresh') {
        this.pagination.mountings.current = 1
      }
      this.loadingObj.mountings = true
      const reponse = await getMountingsApi(this.condition.mountings, this.pagination.mountings)
      const { current, total, size, records } = reponse.data
      this.dialog.mountings = records
      this.pagination.mountings.total = total
      this.pagination.mountings.current = current
      this.pagination.mountings.size = size
      this.loadingObj.mountings = false
    },
    handleMountingsDelete(index) {
      this.form.mountingsList.splice(index, 1)
    },
    handleMountingsChange(val) {
      for (const item of val) {
        if (item?.id) {
          delete item.id
        }
      }
      this.selection.mountings = val
    },
    mountingsConfirm() {
      const arr = JSON.parse(JSON.stringify(this.form.mountingsList))
      if (arr !== null && arr.length > 0) {
        this.form.mountingsList = mergeObjectArrayWithoutDuplicates(arr, this.selection.mountings, 'productCode', 'batch')
      } else {
        this.form.mountingsList = this.selection.mountings
      }
      // if (!isNaN(this.taxRatio)) {
      //   this.form.mountingsList.forEach((item, index) => {
      //     this.$set(this.form.mountingsList[index], 'taxRatio', this.taxRatio)
      //   })
      // }
      this.showObj.mountings = false
    },
    mountingsClose() {
      this.showObj.mountings = false
    },
    // 废料
    // addFlotsamLine() {
    //   if (!this.form.deliveryOrderSn) {
    //     this.$message.warning('请先选择交货单号，再添加订单明细')
    //     return
    //   }
    //   this.showObj.flotsam = true
    //   this.getFlotsam()
    // },
    // delectFlotsamLine() {
    //   this.form.flotsamList = []
    // },
    // async getFlotsam(type = '') {
    //   if (type === 'refresh') {
    //     this.pagination.flotsam.current = 1
    //   }
    //   this.loadingObj.flotsam = true
    //   this.condition.flotsam.productType = 2
    //   this.condition.flotsam.deliveryOrderId = this.form.deliveryOrderId
    //   const reponse = await getDetailPage(this.condition.flotsam, this.pagination.flotsam)
    //   const { current, total, size, records } = reponse.data
    //   this.dialog.flotsam = records
    //   this.pagination.flotsam.total = total
    //   this.pagination.flotsam.current = current
    //   this.pagination.flotsam.size = size
    //   this.loadingObj.flotsam = false
    // },
    // handleFlotsamDelete(index) {
    //   this.form.flotsamList.splice(index, 1)
    // },
    // handleFlotsamChange(val) {
    //   this.selection.flotsam = val
    // },
    // flotsamConfirm() {
    //   const arr = JSON.parse(JSON.stringify(this.form.flotsamList))
    //   if (arr !== null && arr.length > 0) {
    //     this.form.flotsamList = mergeObjectArrayWithoutDuplicates(arr, this.selection.flotsam, 'productCode')
    //   } else {
    //     this.form.flotsamList = this.selection.flotsam
    //   }

    //   if (!isNaN(this.taxRatio)) {
    //     this.form.flotsamList.forEach((item, index) => {
    //       this.$set(this.form.flotsamList[index], 'taxRatio', this.taxRatio)
    //     })
    //   }
    //   console.log(this.form.flotsamList)
    //   this.showObj.flotsam = false
    // },
    // flotsamClose() {
    //   this.showObj.flotsam = false
    // },
    // 审批人
    async getNodePersonDialog() {
      this.loadingObj.nodePerson = true
      const reponse = await getByGeneralManager(this.condition.nodePerson.nodePerson, this.form.roleId, this.pagination.nodePerson)
      const { current, total, size, records } = reponse.data
      this.dialog.nodePerson = records
      this.pagination.nodePerson.total = total
      this.pagination.nodePerson.current = current
      this.pagination.nodePerson.size = size
      this.loadingObj.nodePerson = false
    },
    async getFlowTempInfoList(e) {
      this.loading = true
      this.form.flowPathNodePersonModels = []
      const i = this.flowPathOptions.findIndex(v => v.id === e)
      this.form.roleId = this.flowPathOptions[i].roleId
      try {
        const res = await getFlowTempInfo(this.flowPathOptions[i].templateName)
        const nodeList = res.data.nodeList
        nodeList.shift()
        for (const item of nodeList) {
          let nodeVariate = ''
          const arr = []
          for (const v of item.userList) {
            if (v.variable) {
              v.username = v.username.substring(2, 13)
            }
            arr.push(v.username)
          }
          nodeVariate = arr.join()

          // 指定审核人赋值
          let nodePerson = null
          if (!item.userList[0].variable) {
            nodePerson = nodeVariate
          } else {
            nodePerson = null
          }
          this.form.flowPathNodePersonModels.push({
            nodePersonName: item.name,
            nodeVariate,
            nodePerson,
            nodePersonId: null,
            variable: item.userList[0].variable
          })
        }
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    // addNodePerson() {
    //   if (this.form.flowPathNodePersonModels === null) {
    //     this.form.flowPathNodePersonModels = []
    //   }
    //   this.form.flowPathNodePersonModels.push({})
    // },
    // deleteNodePerson(index) {
    //   this.form.flowPathNodePersonModels.splice(index, 1)
    // },

    handleNodePersonSelectionChange(val) {
      this.selection.nodePerson = val
    },
    selectNodePerson(index) {
      this.nodePersonIndex = index
      this.showObj.nodePerson = true
      this.getNodePersonDialog()
    },

    nodePersonConfirm() {
      if (this.selection.nodePerson.length > 1) {
        this.$message.warning('只能选择一位审批人！')
      } else {
        this.showObj.nodePerson = false
        console.log(this.selection.nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePerson', this.selection.nodePerson[0].nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePersonId', this.selection.nodePerson[0].nodePersonId)
      }
    },
    nodePersonClose() {
      this.showObj.nodePerson = false
    },
    async getData() {
      if (!this.editId) return
      this.loading = true
      try {
        const response = await get(this.editId)
        const { data } = response
        this.form = data

        this.$set(this.form, 'mountingsList', [])
        this.$set(this.form, 'flotsamList', [])

        if (this.form.crmPreSaleOrderLineModels && this.form.crmPreSaleOrderLineModels.length > 0) {
          for (const item of this.form.crmPreSaleOrderLineModels) {
            if (item.productType === 1) {
              this.form.mountingsList.push(item)
            } else {
              this.form.flotsamList.push(item)
            }
          }
        }
        if (this.form.mountingsList.length <= 0 && this.form.flotsamList.length > 0) {
          this.activePaneName = 'flotsam'
        }
        this.flowRejectTo(null, null)
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    handleClose() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$router.push({ query: {} })
      this.$emit('close')
    },
    async submitForm(formName, isClose = true, cb) {
      // ---- 需要手工填写此代码 -----
      this.$refs[formName].validate(async (valid, obj) => {
        if (valid) {
          // ---- 需要手工填写此代码 -----
          try {
            this.loading = true

            const formData = JSON.parse(JSON.stringify(this.form))

            formData.crmPreSaleOrderLineModels = formData.mountingsList.concat(formData.flotsamList)
            if (formData.crmPreSaleOrderLineModels.length <= 0) {
              this.$message.warning('订单明细不能为空')
              this.loading = false
              return
            }
            delete formData.mountingsList
            delete formData.flotsamList
            const { message, data } = await saveOrUpdate(formData)
            this.$message({
              type: 'success',
              message: message
            })
            this.form.id = this.form.id || data
            this.editId = this.form.id || data
            await this.getData()
            this.loading = false
            if (cb) {
              await cb()
            }
            if (isClose) {
              this.handleClose()
            }
          } catch (error) {
            this.loading = false
          }
        } else {
          for (const key in obj) {
            this.$message({
              type: 'warning',
              message: obj[key][0].message
            })
            return false
          }
          return false
        }
      })
    },
    flowLoad(e) {
      this.flowOptions = e
      this.$refs.flow.validatorForm.push(this.$refs.isProceeds)
    },
    flowRejectTo(isAssignee, nodeName) {
      if (isAssignee && nodeName === '开始') {
        this.isRejectTo = false
      } else {
        if (this.form.status > 1) {
          this.isRejectTo = true
        } else {
          this.isRejectTo = false
        }
      }
    },
    flowRefresh() {
      this.getData()
      this.handleClose()
    },
    // 流程提交
    async onComplete() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      // if (!this.form.flowPathNodePersonModels) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请选择审批人'
      //   })
      //   return
      // }
      // if (this.form.flowPathNodePersonModels.length !== 2) {
      //   this.$message({
      //     type: 'warning',
      //     message: '只能选择两名审批人'
      //   })
      //   return
      // }
      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitForm('form', false, async () => {
        // await this.getData();
        // 在执行提交
        await this.$refs.flow.onComplete()
        this.handleClose()
      })
    },
    // 保存并提交
    async saveAndSubmit() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      // if (!this.form.flowPathNodePersonModels) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请选择审批人'
      //   })
      //   return
      // }
      // if (this.form.flowPathNodePersonModels.length !== 2) {
      //   this.$message({
      //     type: 'warning',
      //     message: '只能选择两名审批人'
      //   })
      //   return
      // }
      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitForm('form', false, async () => {
        await this.submit()
      })
    },
    async submit() {
      try {
        this.loading = true
        const response = await submit(this.form.id)
        this.form.flowId = response.data
        this.loading = false
        // this.handleClose()
        this.getData()
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.link {
  color: #606266;
  font-weight: lighter;
}
.link:hover {
  color: rgb(64, 158, 255);
  font-weight: lighter;
}
.upload {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
}
.upload >>> .el-upload-list__item:first-child {
  margin-top: 0;
}
.uploads {
  clear: both;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.el-upload {
  flex: 1;
}

.el-upload__tip {
  margin-top: 0;
  margin-left: 10px;
  flex: 1;
}
.el-col {
  min-height: 50px;
}
</style>

